module.exports = __webpack_public_path__ + "static/media/need-connected.ba48ba45.jpg";